import React from 'react';
/**
 * the user context encapsulates the current signed in users
 * details, and provides a method to update the oauth state 
 * of the app
 */
export let UserContext = React.createContext({
    profile: null,
    login: async (domain, password) => {},
    logout: async () => {},
})

